<template>
  <main>
    <Navigation fixed left-0 right-0 top-0 z-10 w-full />

    <slot />
  </main>
</template>
